import React from 'react';
import Navigation from '../Navigation/Navigation';
import * as styles from './footer.module.scss';


export default function Footer() {
  return (
    <footer className={ styles.footer }>
      <div className={ styles.footerInner }>
        <div className={ styles.footerNavigation }>
          <Navigation id="footer-navigation" />
        </div>

        <div className={ styles.footerCopyright }>
          <p>RyuseiLight is released under the MIT license.</p>
          <p>© { new Date().getFullYear() } Naotoshi Fujita</p>
        </div>
      </div>
    </footer>
  );
}